import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  getSticker: {
    method: 'GET',
    url: `${configs.baseUrl}/api/stickers/sticker`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const getSticker = async () => {
  const res = await resource.getSticker()

  return res.body
}

export default {
  initResource,
  getSticker,
}
